var map = {
	"./demos/accordion/index.ts": 84922,
	"./demos/arrow/index.ts": 78152,
	"./demos/basic/index.ts": 13725,
	"./demos/noBorder/index.ts": 61778,
	"./demos/title/index.ts": 40386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47793;